module.exports = __webpack_public_path__ + "ourwedding_wh.82c06173c35fc211a7cd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animations/ourwedding_wh.gif
// module id = ./src/assets/images/animations/ourwedding_wh.gif
// module chunks = main